import { render, staticRenderFns } from "./SizeTableSettings.vue?vue&type=template&id=501d0008&scoped=true"
import script from "./SizeTableSettings.vue?vue&type=script&lang=ts"
export * from "./SizeTableSettings.vue?vue&type=script&lang=ts"
import style0 from "./SizeTableSettings.vue?vue&type=style&index=0&id=501d0008&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d0008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501d0008')) {
      api.createRecord('501d0008', component.options)
    } else {
      api.reload('501d0008', component.options)
    }
    module.hot.accept("./SizeTableSettings.vue?vue&type=template&id=501d0008&scoped=true", function () {
      api.rerender('501d0008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/SizeTableSettings.vue"
export default component.exports